import { MUIDataTableColumn } from "mui-datatables";
import { Vocabulary } from "../../../Utils/Vocabulary";
import { OrderStatusModel, WorkPointModel } from "../../../Utils/Models";
import { EComponentTypes } from "../../../Utils/Enums";
import { OrderStatusType } from "../../../Utils/Utils";

/**
 * Generate columns for the order status report.
 *
 * The columns returned are as follows:
 * - a column for the product name, with the column name "productName" and
 *   label as the translation of "product",
 * - a column for each order status, with the column name and label as the
 *   name of the order status.
 *
 */
export const orderStatusColumns = (
  orderStatuses: OrderStatusModel[]
): MUIDataTableColumn[] => [
  {
    name: "productName",
    label: Vocabulary.product,
    options: {
      setCellProps: () => ({
        style: {
          position: "sticky",
          left: 0,
          background: "#fff",
          zIndex: 1000,
        },
      }),
    },
  },
  ...(orderStatuses.map((status: any) => ({
    name: status.name,
    label: status.name,
    options: {
      customBodyRender: (value: any) => value ?? 0,
    },
  })) ?? []),
];

/**
 * additional filters for the order status report
 */
export const orderStatusFilters = (workPoints: WorkPointModel[]) => [
  {
    property: "orderStatusType",
    autocompleteFilterProperty: "_id",
    label: Vocabulary.account,
    type: EComponentTypes.AUTOCOMPLETE,
    validation: null,
    defaultValue: OrderStatusType.License,
    options: [OrderStatusType.License, OrderStatusType.Certification],
    otherOptions: { disableClearable: true },
  },
  {
    property: "workPointId",
    autocompleteFilterProperty: "_id",
    label: Vocabulary.workPoint,
    type: EComponentTypes.AUTOCOMPLETE,
    validation: null,
    defaultValue: null,
    options: workPoints,
  },
];
